export default __webpack_public_path__ + "static/media/dm.646f01ba.svg";